import { TableDensity, useOverflow, useTableDensity } from '@factorialco/deprecated-design-system'

import { selectableColumnWidth } from 'modules/core/components/DataTable/constants'

function isSticky(
  index: number,
  cellsLength: number,
  sticky: boolean,
  isOverflow: boolean,
  tableDensity: TableDensity,
  selectable: boolean
) {
  const isFirst = index === 0
  const isLast = index === cellsLength - 1
  if (sticky && !isFirst && !isLast) {
    throw new Error('Sticky columns can only be the first or last column in the table')
  }

  const stickyProp = sticky
    ? ({
        position: isFirst ? 'left' : 'right',
        delimiter: isOverflow,
        offset: isFirst && selectable ? selectableColumnWidth(tableDensity) : 0,
      } as const)
    : undefined

  return stickyProp
}

export default function useSticky() {
  const isOverflow = useOverflow()
  const tableDensity = useTableDensity()

  return (index: number, cellsLength: number, sticky: boolean, selectable: boolean) =>
    isSticky(index, cellsLength, sticky, isOverflow, tableDensity, selectable)
}
